<template>
  <div class="c-index">
    <div class="container ">
      <section class="brand">
        <img :src="logo" class="rounded mx-auto mb-4 d-block" alt="Dr.COM"/>
        <blockquote class="blockquote text-center">
          <h1 class="mb-0">Dr.COM Billingware</h1>
          <footer class="blockquote-footer">Dr.COM专注宽带接入与互联网运营解决方案，为高校、商超、景区、运营商等客户提供丰富便捷的应用和服务</footer>
        </blockquote>
      </section>
    </div>
    <div class="container d-none d-sm-block text-right">
      <button type="button" class="btn btn-sm btn-link" disabled>视图</button>
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <label class="btn btn-sm btn-outline-secondary" :class="{'active': productLayoutCol == 1}">
          <input type="radio" v-model="productLayoutCol" value="1" autocomplete="off"> 紧凑
        </label>
        <label class="btn btn-sm btn-outline-secondary" :class="{'active': productLayoutCol == 2}">
          <input type="radio" v-model="productLayoutCol" value="2" autocomplete="off"> 标准
        </label>
        <label class="btn btn-sm btn-outline-secondary" :class="{'active': productLayoutCol == 3}">
          <input type="radio" v-model="productLayoutCol" value="3" autocomplete="off"> 较大
        </label>
        <label class="btn btn-sm btn-outline-secondary" :class="{'active': productLayoutCol == 4}">
          <input type="radio" v-model="productLayoutCol" value="4" autocomplete="off"> 超大
        </label>
      </div>
    </div>
    <div class="container-fluid d-none d-sm-block" v-if="products == null || products.length <= 0">
      <div class="row pt-4">
        <div class="col-12">
          <div class="text-center" style="padding: 80px 0 240px">
            <a-spin />
          </div>
        </div>
      </div>
    </div>
    <template v-if="serviceProducts.length > 0">
      <a-divider>已安装的产品和服务</a-divider>
      <div class="container-fluid d-none d-sm-block" v-show="productLayoutCol > 0">
        <div class="row pt-4">
          <div :class="`col-${productLayoutCol}`" class="animated fadeInUp" v-for="product in serviceProducts" :key="product.name">
            <a class="d-block text-decoration-none" 
              :href="product.target === '_blank' ? (product.contextPath + product.href) : ('#' + product.name)" 
              :target="product.target === '_blank' ? '_blank' : ''"
              @click="triggerNavChange(product)">
              <figure class="figure">
                <div class="figure-body">
                  <img class="figure-img mb-0 w-100" :class="{'gray': !product.running}" :src="product.contextPath + product.snapshotUrl" :alt="product.title">
                  <div class="d-hover">
                    <button type="button" class="btn btn-sm btn-secondary">进入组件</button>
                  </div>
                </div>
                <figcaption class="figure-caption h6 pt-2 mb-4 text-md">
                  <h5>{{product.title}}</h5>
                  <small>{{product.detail}}</small>
                </figcaption>
              </figure>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template v-if="settingProducts.length > 0">
      <a-divider>系统管理工具</a-divider>
      <div class="container-fluid d-none d-sm-block" v-show="productLayoutCol > 0">
        <div class="row pt-4">
          <div :class="`col-${productLayoutCol}`" class="animated fadeInUp" v-for="product in settingProducts" :key="product.name">
            <a class="d-block text-decoration-none" 
              :href="product.target === '_blank' ? (product.contextPath + product.href) : ('#' + product.name)" 
              :target="product.target === '_blank' ? '_blank' : ''"
              @click="triggerNavChange(product)">
              <figure class="figure">
                <div class="figure-body">
                  <img class="figure-img mb-0 w-100" :class="{'gray': !product.running}" :src="product.contextPath + product.snapshotUrl" :alt="product.title">
                  <div class="d-hover">
                    <button type="button" class="btn btn-sm btn-secondary">进入组件</button>
                  </div>
                </div>
                <figcaption class="figure-caption h6 pt-2 mb-4 text-md">
                  <h5>{{product.title}}</h5>
                  <small>{{product.detail}}</small>
                </figcaption>
              </figure>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template v-if="noserviceProducts.length > 0">
      <a-divider>未安装或已关闭的组件</a-divider>
      <div class="container-fluid d-none d-sm-block" v-show="productLayoutCol > 0">
        <div class="row pt-4">
          <div :class="`col-${productLayoutCol}`" class="animated fadeInUp" v-for="product in noserviceProducts" :key="product.name">
            <a class="d-block text-decoration-none" 
              :href="'#' + product.name" @click="gotoDAM">
              <figure class="figure">
                <div class="figure-body">
                  <img class="figure-img mb-0 w-100" :class="{'gray': !product.running}" :src="product.contextPath + product.snapshotUrl" :alt="product.title">
                  <div class="d-hover">
                    <button type="button" class="btn btn-sm btn-secondary">安装组件</button>
                  </div>
                </div>
                <figcaption class="figure-caption h6 pt-2 mb-4 text-md">
                  <h5>{{product.title}}</h5>
                  <small>{{product.detail}}</small>
                </figcaption>
              </figure>
            </a>
          </div>
        </div>
      </div>
    </template>
    <div class="footer">
      <div class="container">
        <div class="row">
          <div class="col-6 mt-4 mb-2 pl-4 pr-4 border-right">
            <div class="d-flex justify-content-around align-items-center">
              <figure class="figure">
                <img :src="wechatDrcom" style="width: 100px; height: 100px" class="figure-img img-fluid rounded" alt="官方微信	">
                <figcaption class="figure-caption text-center">官方微信	</figcaption>
              </figure>
              <figure class="figure">
                <img :src="wechatDuodian" style="width: 100px; height: 100px" class="figure-img img-fluid rounded" alt="哆点APP">
                <figcaption class="figure-caption text-center">哆点APP</figcaption>
              </figure>
            </div>
          </div>
          <div class="col-6 mt-4 mb-2 pl-4 pr-4">
            <div class="text-left">
              <p class="mb-0 font">全国销售热线</p>
              <h3 class="text-light">400-700-3886</h3>
              <p>全国客服热线</p>
              <h3 class="text-light">400-700-9758</h3>
            </div>
          </div>
        </div>
      </div>
      <hr/>
      <div class="text-center">
        <span>版权所有© 广州热点软件科技股份有限公司 1995-{{ (new Date()).getFullYear() }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import logo from '@/assets/logo.svg'
import wechatDrcom from '@/assets/wechat-drcom.svg'
import wechatDuodian from '@/assets/wechat-duodian.svg'

export default {
  name: 'DrIndex',
  props: ['products'],
  methods: {
    triggerNavChange(view) {
      if (!view.running) {
        return;
      }
      if (view != null && view.target !== '_blank') {
        this.$emit('nav-change', view)
      }
    },
    gotoDAM() {
      // 打开统一授权管理平台安装组件，如果连统一授权管理平台都无服务，着弹出错误
      let dam = this.$_.find(this.products, ['name', 'DrcomAuthMgmt'])
      if (dam == null || !dam.running) {
        this.$notification['error']({
          message: '提示信息',
          description: "系统异常，无法安装组件！"
        });
        return;
      }
      this.triggerNavChange(dam)
    }
  },
  computed: {
    noserviceProducts() {
      return this.$_.filter(this.products, (p) => {
        return !p.running;
      })
    },
    serviceProducts () {
      return this.$_.filter(this.products, (p) => {
        return p.running && this.$_.includes(['DrcomManager','MAuth','WebPayManager','ns','Authser','ScheduleCtrl','DrcomSrvManager','V6Manager'], p.name)
      })
    },
    settingProducts () {
      return this.$_.filter(this.products, (p) => {
        return p.running && this.$_.includes(['cas-user-mgmt','introduction', 'SpringBootAdmin','DrcomSso','DrcomAuthMgmt', 'CAS-Dashboard'], p.name)
      })
    },
    otherProducts () {
      return this.$_.filter(this.products, (p) => {
        return p.running && !this.$_.includes(['DrcomManager','MAuth','WebPayManager','ns','Authser','ScheduleCtrl','DrcomSrvManager','DrcomSso','V6Manager', 'cas-user-mgmt','introduction', 'SpringBootAdmin', 'DrcomAuthMgmt', 'CAS-Dashboard'], p.name)
      })
    }
  },
  data() {
    return {
      logo,
      wechatDrcom,
      wechatDuodian,
      productLayoutCol: 2, // 产品所占格数（一行 12 格）
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
.gray { 
  -webkit-filter: grayscale(80%);
  -moz-filter: grayscale(80%);
  -ms-filter: grayscale(80%);
  -o-filter: grayscale(80%);
  filter: grayscale(80%);
  filter: gray;
}
</style>
